module.exports = __webpack_public_path__ + "static/media/3.a13574a0.png";